import { Card, CardContent, CardHeader, Typography } from '@mui/material';

import { KioskImageSetFragment } from '@occc/graphql';

import { AssetImagePreview } from '../../assets-details-page/components/asset-image-preview.component';

type AdSetAssetPreviewCardProps = {
  imageSet: KioskImageSetFragment;
};

export const AdSetAssetPreviewCard = ({ imageSet }: AdSetAssetPreviewCardProps) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant='subtitle1' fontWeight={500}>
            Asset Preview
          </Typography>
        }
      />
      <CardContent sx={{ overflowX: 'auto' }}>
        <AssetImagePreview imageSet={imageSet} />
      </CardContent>
    </Card>
  );
};
